export default "__VITE_ASSET__Bq8i6XVT__"